import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";

const ProtectedLayout = ({ children }) => {
    const token = localStorage.getItem("token");

    useEffect(() => {
        const checkSession = async () => {
            try {
                const res = await axios.get(
                    `${process.env.REACT_APP_API_URL}/token-is-valid`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                console.log(res);
            } catch (err) {
                console.error("Token validation failed:", err);
                // localStorage.removeItem("token");
                // window.location.href = "/admin/login";
            }
        };


        checkSession();

    }, [token]);

    if (!token) {
        return <Navigate to="/admin/login" replace />;
    }

    return children;
};

export default ProtectedLayout;